import { render, staticRenderFns } from "./DatasourceCreate.vue?vue&type=template&id=684fec76&"
import script from "./DatasourceCreate.vue?vue&type=script&lang=js&"
export * from "./DatasourceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684fec76')) {
      api.createRecord('684fec76', component.options)
    } else {
      api.reload('684fec76', component.options)
    }
    module.hot.accept("./DatasourceCreate.vue?vue&type=template&id=684fec76&", function () {
      api.rerender('684fec76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DatasourceCreate.vue"
export default component.exports